import { BookOpen, Users } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  RolePermission,
  GlossaryTerm
} from '../../types';

import UserManagement from '../../components/Settings/UserManagement';

const SettingsPage: React.FC = () => {
  const { t } = useTranslation();
  const rolesPermissions: RolePermission[] = [];
  const glossaryTerms: GlossaryTerm[] = [];

  return (
    <div className="space-y-8 p-6">
      <h1 className="text-3xl font-bold text-foreground mb-6">{t('settings.pageTitle')}</h1>

      <UserManagement />

      <div className="rounded-lg border border-border bg-card overflow-hidden">
        <div className="p-5 border-b border-border bg-muted/50">
          <h2 className="text-xl font-semibold text-foreground flex items-center">
            <Users className="h-5 w-5 mr-2 text-purple-600" /> {t('settings.rolesTitle')}
          </h2>
        </div>
        <div className="p-5 space-y-3">
          {rolesPermissions.length === 0 && (
            <p className="text-sm text-muted-foreground">{t('settings.noRoles')}</p>
          )}
          {rolesPermissions.map((rolePerm: RolePermission, index: number) => (
            <div key={index} className="p-3 border rounded-md bg-muted/30 border-border">
              <h3 className="font-semibold text-foreground">{rolePerm.role}</h3>
              {rolePerm.description && <p className="text-sm text-muted-foreground mt-1">{rolePerm.description}</p>}
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-border bg-card overflow-hidden">
        <div className="p-5 border-b border-border bg-muted/50">
          <h2 className="text-xl font-semibold text-foreground flex items-center">
            <BookOpen className="h-5 w-5 mr-2 text-yellow-600" /> {t('settings.glossaryTitle')}
          </h2>
        </div>
        <div className="p-5 space-y-4">
          {glossaryTerms.length === 0 && (
            <p className="text-sm text-muted-foreground">{t('settings.noGlossaryTerms')}</p>
          )}
          {glossaryTerms.map((term: GlossaryTerm, index: number) => (
            <div key={index}>
              <p className="text-md font-semibold text-foreground">{term.term}</p>
              <p className="text-sm text-muted-foreground mt-1">{term.definition}</p>
              {term.category && <span className="mt-1 inline-block bg-muted text-muted-foreground text-xs font-medium px-2 py-0.5 rounded">{term.category}</span>}
            </div>
          ))}
        </div>
      </div> {/* Fermeture du div bg-white... pour Glossaire */}
    </div>
  );
};

export default SettingsPage;
